<div class="container mt-5">
  <div class="mb-4">
    <h2 class="text-center">
      <i class="fa fa-spinner fa-spin fa-7x"></i>
    </h2>
  </div>
</div>
